<template>
  <div class="my-5">
    <Label>{{ label }}</Label>
    <Input
      :type="type"
      :name="name"
      :model-value="modelValue"
      class="mt-2"
      @update:modelValue="$emit('update:modelValue', $event)"
    />
  </div>
</template>

<script setup>
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

defineProps({
  label: { type: String, required: true },
  name: { type: String, required: true },
  type: { type: String, default: "text" },
  modelValue: { type: [String, Number], default: "" },
});

defineEmits(["update:modelValue"]);
</script>
